/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ZzzingServicePricing } from './zzzingServicePricing';
import { ZzzingServicePricingAndAvailability } from './zzzingServicePricingAndAvailability';
import { TaxCategoryCode } from './taxCategoryCode';
import { ZzzingServiceBookingCountType } from './zzzingServiceBookingCountType';


export interface ZzzingGuestServiceDetails { 
    id?: string;
    title?: string;
    summary?: string;
    description?: string;
    booking_cutoff_days?: number;
    bookable_after_checkin?: boolean;
    image?: string;
    tax_category?: TaxCategoryCode;
    booking_count_type?: ZzzingServiceBookingCountType;
    pricing?: ZzzingServicePricing;
    pricing_and_availabilities?: Array<ZzzingServicePricingAndAvailability>;
}

